module.exports = __webpack_public_path__ + "static/media/sensor.5335f4d9.png";